
import { Component } from '@angular/core';
import { RyderUIModule } from '@ryder/ryder-ui-library';

@Component({
    selector: 'app-spinner-wrapper',
    imports: [RyderUIModule],
    templateUrl: './spinner-wrapper.component.html',
    styleUrls: ['./spinner-wrapper.component.scss']
})
export class SpinnerWrapperComponent {

}
